import { render } from "./CarouselSkeleton.vue?vue&type=template&id=4e198e7e&lang=pug"
import script from "./CarouselSkeleton.vue?vue&type=script&lang=js"
export * from "./CarouselSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
